var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0028 17.5001L5.89731 20.1842C5.28626 20.5054 4.53047 20.2705 4.20922 19.6594C4.0813 19.4161 4.03715 19.1374 4.08362 18.8664L5.05868 13.1814L0.928267 9.15525C0.433913 8.67338 0.423797 7.88199 0.905674 7.38763C1.09756 7.19078 1.34899 7.06267 1.62103 7.02314L7.32913 6.1937L9.88187 1.02129C10.1874 0.402223 10.9369 0.14805 11.556 0.453577C11.8025 0.57524 12.002 0.774775 12.1237 1.02129L14.6764 6.1937L20.3845 7.02314C21.0677 7.12241 21.5411 7.75671 21.4418 8.43989C21.4023 8.71194 21.2742 8.96337 21.0773 9.15525L16.9469 13.1814L17.9219 18.8664C18.0386 19.5469 17.5817 20.1931 16.9012 20.3098C16.6303 20.3562 16.3516 20.3121 16.1083 20.1842L11.0028 17.5001Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.327b1b5d.svg";
export { ForwardRef as ReactComponent };